import * as types from './types';

const INITIAL_STATE = {
  online: window.navigator.onLine,
  serverUp: true,
  offlineMode: false,
  offlineSyncInProgress: false,
};

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case types.SET_ONLINE:
      return {
        ...state,
        online: payload,
      };
    case types.SET_SERVER_UP:
      return {
        ...state,
        serverUp: payload,
      };
    case types.SET_OFFLINE_MODE:
      return {
        ...state,
        offlineMode: payload,
      };
    case types.SET_OFFLINE_SYNCE_IN_PROGRESS:
      return {
        ...state,
        offlineSyncInProgress: payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/state/connection/reducer.js